export default "__VITE_ASSET__CGVE2wY2__"